const appState = {
  teamsInMenu: [],
  selectedTeam: {
    shield: null,
    name: '',
    id: 0,
    color: '',
  },
  generalStatistics: null,
};

export default appState;



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/constants.js